/**
 * Caliceo Store Model
 */
export class Alert {
  id: string;
  index: number;
  title: string;
  color: string;
  url: string;
  from: string;
  to: string;
  centers: string[]

  /**
   * Construct alert from a partial alert object
   * @param alert A Alert like object
   */
  constructor(alert?: Partial<Alert>) {
    this.id = alert?.id ?? '';
    this.index = alert?.index ?? 0;
    this.title = alert?.title ?? '';
    this.color = alert?.color ?? '#5a2412';
    this.url = alert?.url ?? '';
    this.from = alert?.from ?? '';
    this.to = alert?.to ?? '';
    this.centers = alert?.centers ?? [];
  }
}
